import { useDashboardStats } from '@/hooks/useDashboardStats';
import { StatsCards } from '@/components/dashboard/StatsCards';

export default function Dashboard() {
  const { stats, loading, error } = useDashboardStats();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-lg text-slate-600 dark:text-neutral-400">Loading dashboard...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-lg text-red-600">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="h-full bg-gradient-to-br from-slate-50 to-slate-100 dark:from-neutral-950 dark:to-neutral-900 p-8 flex flex-col">
      <div className="max-w-7xl mx-auto space-y-8 flex-1">
        <header>
          <h1 className="text-3xl font-bold text-slate-900 dark:text-neutral-100 mb-2">Dashboard</h1>
          <p className="text-slate-600 dark:text-neutral-400">Welcome back! Here's your overview.</p>
        </header>

        <StatsCards stats={stats} />
      </div>
      <footer className="mt-8">
        <p className="text-center text-xs text-slate-500 dark:text-neutral-500">
          © 2026 Warner Bros. Discovery. Internal use only.
        </p>
      </footer>
    </div>
  );
}
